import React from "react";
import { EuiIcon } from "@elastic/eui";
import DistanceIcon from "../../shared/icons/DistanceIcon";
import { SHAMROCK, JAFFA, CORNFLOWER_BLUE, BRINK_PINK } from "../../../constants/style/colors";

export default [
    { name: "trucksCount", entityName: "Trucks", color: SHAMROCK },
    { name: "driversCount", entityName: "Drivers", color: JAFFA },
    {
        name: "tripsCount",
        unit: "Trips",
        title: "Total Trips",
        color: CORNFLOWER_BLUE,
        icon: <EuiIcon type="list" />,
    },
    {
        name: "totalDistance",
        unit: "KMs",
        title: "Total Distance in KMs",
        color: BRINK_PINK,
        icon: <DistanceIcon />,
    },
];
